import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const PRODUCT_LINKS = [
  { label: "Kachoris", to: "/categories" },
  { label: "Sweets", to: "/categories" },
  { label: "Combo", to: "/categories" },
  { label: "Winter Special", to: "/categories" },
  { label: "Festival Special", to: "/categories" },
  { label: "Hampers", to: "/categories" },
];

const QUICK_LINKS = [
  { label: "Terms & Conditions", to: "/terms-conditions" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Return & Refund Policy", to: "/return-refund-policy" },
  { label: "FAQ", to: "/static-page/faq/" },
];

function Footer() {
  return (
    <footer className="kuku-footer">
      <div className="kuku-footer__container">
        <div className="kuku-footer__grid">
          <div className="kuku-footer__brand">
            <img
              src="/kuku-assets/images/kuku-namkeen-logo.png"
              className="kuku-footer__logo mx-auto"
              alt="Kuku Namkeen"
            />
            <br />
            <label className="kuku-footer__cert-title">: CERTIFIED BY :</label>
            <div className="kuku-footer__certify">
              <img src="/kuku-assets/images/FSSAI.webp" alt="FSSAI" />
              <img src="/kuku-assets/images/iso22000.png" alt="ISO 22000" />
            </div>
          </div>

          <div className="kuku-footer__column">
            <h4>Products</h4>
            <ul>
              {PRODUCT_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="kuku-footer__column">
            <h4>Quick Links</h4>
            <ul>
              {QUICK_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>

            <h4 className="kuku-footer__connected-title">Stay Connected</h4>
            <div className="kuku-footer__social">
              <a
                href="https://www.facebook.com/profile.php?id=100095135198975&mibextid=ZbWKwL"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <i className="bi bi-facebook"></i>
              </a>
              <a
                href="https://instagram.com/kuku_namkeen?igshid=MzMyNGUyNmU2YQ=="
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <i className="bi bi-instagram"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/kuku-namkeen-234313291?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </div>

          <div className="kuku-footer__column">
            <h4>For Order / Enquiry</h4>
            <ul>
              <li>
                <a href="tel:+918780266042">
                  <i className="bi bi-phone"></i>
                  +91 87802 66042
                </a>
              </li>
              <li>
                <a
                  href="https://api.whatsapp.com/send/?phone=919427265661&text=we%20want%20to%20inquiry%20for%20Kuku%20Products"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-whatsapp"></i>
                  +91 94272 65661
                </a>
              </li>
              <li>
                <a href="mailto:kukunamkeen65@gmail.com">
                  <i className="bi bi-envelope"></i>
                  kukunamkeen65@gmail.com
                </a>
              </li>
            </ul>

            <h4 className="kuku-footer__timing-title">Timing</h4>
            <label className="kuku-footer__timing">
              Mon-Sat : 09:00 AM to 06:00 PM
            </label>
          </div>
        </div>

        <div className="kuku-footer__copyright">
          &copy; {new Date().getFullYear()} by Kuku Foods
        </div>
      </div>
    </footer>
  );
}

export default Footer;
